import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { EPGU_ERROR, epguErrorUrl } from 'SharedDir/backend/endpoints/epgu-errors';
import {
  EpguIssueErrorBare,
  EpguIssueErrorFull,
  EpguIssueErrorReject,
} from 'SharedDir/declarations/epgu-errors';
import { StatusResponse } from 'SharedDir/declarations/tag';

export default class EpguErrorApiClass extends SimpleApi<
  EpguIssueErrorFull,
  never,
  never,
  EpguIssueErrorBare
> {
  constructor() {
    super(epguErrorUrl);
  }

  protected readonly endpoints = EPGU_ERROR;

  public async reject(data: EpguIssueErrorReject) {
    const endpoint = this.endpoints.REJECT;

    const { data: responseData } = (await http({
      ...endpoint,
      data,
    })) as AxiosResponse<StatusResponse>;

    return responseData;
  }
}
